import { usePasswordRequirements } from '../hooks/usePasswordRequirements';

type PasswordRequirementsProps = {
  password: string;
};

export const PasswordRequirements = ({
  password,
}: PasswordRequirementsProps) => {
  const { requirements } = usePasswordRequirements(password);

  return (
    <ul className="mt-4 space-y-2 text-sm">
      {requirements.map((requirement) => (
        <li
          key={requirement.key}
          className={`flex items-center gap-2 ${
            requirement.isValid ? 'text-green-500' : 'text-red-500'
          }`}
        >
          <span aria-hidden>{requirement.isValid ? '✓' : '○'}</span>
          <span>{requirement.label}</span>
        </li>
      ))}
    </ul>
  );
};
